const MuiButtonBase = {
  root: {
    '&:focus': {
      outline: 'none'
    }
  }
};

export default MuiButtonBase;
